import { render } from "./WandModal.vue?vue&type=template&id=4491126d&scoped=true"
import script from "./WandModal.vue?vue&type=script&lang=js"
export * from "./WandModal.vue?vue&type=script&lang=js"

import "./WandModal.vue?vue&type=style&index=0&id=4491126d&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4491126d"]])

export default __exports__